import { StylesDefinition } from "../../../../types";

const stylesDefinition: StylesDefinition = {
    title: {
        default: {
            marginTop: "12vh",
            marginBottom: "8vh",
            textAlign: "center",
            width: "100vw",
            fontSize: "6.5rem",
            zIndex: 2,
            color: "black",
        },
        medium: {
            fontSize: "3.5rem",
            marginTop: "8vh",
            marginBottom: "2vh",
        },
        small: {
            fontSize: "2rem",
            marginTop: "6vh",
            marginBottom: "1vh",
        },
    },
};

export default stylesDefinition;